class InvalidSteps extends Error {}

export default InvalidSteps;
